import PropTypes from "prop-types";
import { MultiSelect } from "primereact/multiselect";
import { getErrorMessage } from "../form/FormStandardProps";
import { useIntl } from "react-intl";
import Label from "./Label";
import { Tag } from "primereact/tag";

const MultiSelectInput = ({
  editable = false,
  input,
  label = "",
  loading = false,
  meta,
  options = [],
  required = false,
  placeholder = "select",
  optionLabel = "name",
  disabled = false,
  filter = false,
  readOnly = false,
  showClear = false,
  showAsTags = true,
  ...rest
}) => {
  const { touched, error } = meta || {};
  const inputProps = input || {};

  const intl = useIntl();

  return (
    <div className="edexlms-field dropdown-input">
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          htmlFor={input.name}
        />
      )) ||
        null}
      <MultiSelect
        {...input}
        id={input.name}
        value={input.value}
        options={options.map((o) => ({
          ...o,
          name: o.i18n ? intl.formatMessage({ id: o.name }) : o.name,
        }))}
        showClear={showClear}
        filter={filter}
        loading={loading}
        optionLabel={optionLabel}
        invalid={touched && error}
        disabled={disabled}
        placeholder={intl.formatMessage(
          { id: "dynamic_select" },
          { label: placeholder }
        )}
        onChange={(e) => !readOnly && input.onChange(e.value)}
        className={`edexlms-field-input w-full`}
      />
      {(showAsTags &&
        input.value &&
        input.value.length > 0 &&
        input.value.map((option) => {
          return (
            <Tag
              style={{
                marginTop: 5,
                marginRight: 5,
              }}
              key={option.id}
              value={option.name}
              severity={null}
            />
          );
        })) ||
        null}
      {(touched && error && (
        <div className="edexlms-field-error">
          {getErrorMessage(error, inputProps, rest, label || placeholder)}
        </div>
      )) ||
        null}
    </div>
  );
};

MultiSelectInput.propTypes = {
  disabled: PropTypes.bool,
  editable: PropTypes.bool,
  filter: PropTypes.bool,
  input: PropTypes.object,
  label: PropTypes.string,
  loading: PropTypes.bool,
  meta: PropTypes.object,
  optionLabel: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  showAsTags: PropTypes.bool,
};

export default MultiSelectInput;
